export default __webpack_public_path__ + "static/media/image-titan.d4b078f9.png";